
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 32 32"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M4 5h24v22H4V5zm2 2v2h20V7H6zm0 4v14h20V11H6zm5.219 2.781l3.5 3.5.688.719-.688.719-3.5 3.5-1.438-1.438L12.562 18l-2.781-2.781zM16 20h6v2h-6v-2z"}})])
          )
        }
      }
    